import styled from "styled-components";

export const StyledTypographyWrapper = styled.div`
    display: flex;
    & > * {
        margin-left: 15px;
        &:nth-child(2) {
            margin-left: 40px;
        }
    }
`;

export const StyledPlace = styled.div`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 30px;
`;
